import {
  RadioGroup,
  RadioGroupProps,
  Stack,
  forwardRef,
} from '@chakra-ui/react';
import { Option } from 'types/general.types';
import { CheckboxRadio } from './CheckboxRadio/CheckboxRadio';
import { ChakraRadio } from '../ChakraRadio/ChakraRadio';

type RenderComponent = 'radio' | 'checkbox';

export interface ChakraRadioGroupProps
  extends Omit<RadioGroupProps, 'children'> {
  options: Option[];
  value: string;
  render?: RenderComponent;
}

export const ChakraRadioGroup = forwardRef(
  (
    {
      options,
      value,
      onChange,
      render = 'radio',
      ...rest
    }: ChakraRadioGroupProps,
    ref
  ) => (
    <RadioGroup
      value={value}
      defaultValue={value}
      onChange={onChange}
      ref={ref}
      {...rest}
    >
      <Stack spacing={22}>
        {options.map((option) => (
          <ChakraRadio
            as={render === 'checkbox' ? CheckboxRadio : undefined}
            key={option.value}
            value={String(option.value)}
          >
            {option.title}
          </ChakraRadio>
        ))}
      </Stack>
    </RadioGroup>
  )
);
